<template>
  <div class="app" :class="{ 'is-edit-page': isEditPage }">
    <NavigationHeader v-if="!hideNavigation" />
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import NavigationHeader from './components/NavigationHeader.vue';
import { useHelpScout } from './composables/useHelpScout';

const route = useRoute();

// Initialize HelpScout integration
useHelpScout();

// Hide navigation on the checkout page. The sign-in page shows the header (logo only).
const hideNavigation = computed(() => route.name === 'checkout');

// Edit page needs fixed viewport, other pages need scrolling
const isEditPage = computed(
  () => route.name === 'project' || route.name === 'project-root' || route.name === 'project-file-nested'
);
</script>

<style>
.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f7fafc;
}

.app.is-edit-page {
  height: 100vh;
  min-height: 0;
  overflow: hidden;
}
</style>
